import { isInsideIframe } from './iframeSession'

export const AUTH_STORAGE_KEYS = {
  brandSession: 'owner-brand-session',
  isMultiBrandUser: 'owner-is-multi-brand-user',
  loginAt: 'owner-session-login-at',
  otpSessionId: 'otp-session-id',
  session: 'owner-session-v2',
  sessionProvider: 'owner-session-provider',
  user: 'owner-user-v2',
} as const

export const EMBED_AUTH_STORAGE_PREFIX = 'owner-embed:'

export const embedAuthStorageKey = (key: string): string =>
  `${EMBED_AUTH_STORAGE_PREFIX}${key}`

// Framed Hermes shares dashboard.owner.com with any top-level dashboard tab.
// Persist embed auth under a separate prefix so hydrate/logout cannot clobber
// or follow the cookie session.
export const persistAuthStorageKey = (key: string): string =>
  isInsideIframe() ? embedAuthStorageKey(key) : key
